<div class="spinner-container mb-3 flex-row justify-center items-center" *ngIf="isLoading$ | async; else jl_edit">
  <mat-progress-spinner color="accent" mode="indeterminate" diameter="30" class="self-center">
  </mat-progress-spinner>
</div>
<ng-template #jl_edit>
  <ng-container *ngIf="data">
    <mat-card data-qa-id="job-requirements-qualifications" *ngIf="showJobRequirementsAndQualifications && data.jobClinicalTrackRequirements; let req" class="job-unit-requirements" [ngClass]="useClass">
      <div>
        @if (allowJobAndUDWithCTRequirementsComparisonEnabled) {
            @if (shouldDisplayComparison) {
                <div class="job-requirements-changes-note">
                    <div class="job-requirements-changes-note__icon">
                        <mat-icon>info</mat-icon>
                    </div>
                    <div class="job-requirements-changes-note__content" data-qa-id="an_rjd_requirements-changes-note">
                        @if (this.data.matchType === matchType.UnitRequirements || this.data.matchType === matchType.UnitTrack) {
                            Job requirements no longer align with the UD. This affects the match breakdown and how the job is displayed in Aya Talent Marketplace. The current tab contains the most accurate job requirements. Use the toggle to compare with UD.
                        }
                        @else if (this.data.matchType === matchType.JobTrack) {
                            Clinical Track is in use and job requirements have been edited. Job requirements no longer align with the Clinical Track. This affects the match breakdown and how the job is displayed in Aya Talent Marketplace. The edited version tab contains the most accurate job requirements. Use the toggle to compare with the Clinical Track.
                        }
                    </div>
                </div>

				<div class="gap-8 flex-col job-requirements-header-spacer">
	                <div class="row-margin flex-row job-requirements-header">
	                    <h1>Job Requirements & Qualifications</h1>

	                    <mat-button-toggle-group class="mat-button-toggle-group-small flex-col" [value]="(compareSelection$ | async)" (change)="onChangesToggled($event)" data-qa-id="ayaChangesTypeToggler">
	                    <mat-button-toggle [value]="currentToggleText" data-qa-id="ayaChangesTypeCurrentToggle">Current</mat-button-toggle>
	                    <mat-button-toggle [value]="compareToggleText" data-qa-id="ayaChangesTypeCompareToggle">{{comparisonText}}</mat-button-toggle>
	                    </mat-button-toggle-group>
	                </div>

					<div class="job-requirements-updated-date justify-end" data-qa-id="job-requirements-updated-date">
	    	            Edits made on {{data.jobRequirementsUpdatedDate | lenientDate:'M/d/yy h:mm a':true}}
    	    	    </div>
				</div>

                <ng-container *ngIf="compareSelection$ | async as compareSelection">
                    @if (compareSelection === currentToggleText) {
                        <ng-container *ngTemplateOutlet="requirements; context: { $implicit: req }"></ng-container>
                    }
                    @else if (compareSelection === compareToggleText) {
                        <nova-job-qualifications-compare [jobId]="jobId"></nova-job-qualifications-compare>
                    }
                </ng-container>
            }
            @else {
                <div class="flex-row job-requirements-header job-requirements-header-spacer">
	              <h1>Job Requirements & Qualifications</h1>
	            </div>

                <ng-container *ngTemplateOutlet="requirements; context: { $implicit: req }"></ng-container>
            }
        }
        @else {
            <ng-container *ngIf="data.matchType === matchType.UnitRequirements && data.hasJobLevelEdits && !data.allChangesMatch; else nonToggle">
                <div class="job-requirements-changes-note">
                    <div class="job-requirements-changes-note__icon">
                        <mat-icon>info</mat-icon>
                    </div>
                    <div class="job-requirements-changes-note__content">
                    Job requirements no longer align with the UD. This affects the match breakdown and how the job is displayed in Aya Talent Marketplace. The current tab contains the most accurate job requirements. Use the toggle to compare with UD.
                    </div>
                </div>


                <div class="row-margin flex-row job-requirements-header">
                    <h1>Job Requirements & Qualifications</h1>

                    <mat-button-toggle-group class="mat-button-toggle-group-small flex-col" [value]="(udCompareSelection$ | async)" (change)="onUdChangesToggled($event)" data-qa-id="ayaStandardTypeToggler">
                    <mat-button-toggle value="current">Current</mat-button-toggle>
                    <mat-button-toggle value="ud-compare">UD Comp</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <ng-container *ngIf="udCompareSelection$ | async as udCompareSelection">
                    <ng-container *ngIf="udCompareSelection === 'current'">
                        <ng-container *ngTemplateOutlet="requirements; context: { $implicit: req }"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="udCompareSelection === 'ud-compare'">
                        <nova-job-qualifications-compare [jobId]="jobId"></nova-job-qualifications-compare>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-template #nonToggle>
                <div class="row-margin flex-row job-requirements-header">
                <h1>Job Requirements & Qualifications</h1>
                </div>

                <ng-container *ngTemplateOutlet="requirements; context: { $implicit: req }"></ng-container>
            </ng-template>
        }
      </div>
    </mat-card>

    <div class="wrap-divider">
        <hr>
    </div>

    <ng-template #requirements let-req>
      <div class="row-margin">
        <div class="col-item flex-row">
          <strong class="flex-40 nova__label"
            >Previous Charge Experience:</strong
          >
          <span
            flex
            class="flex-60 capitalize"
            data-qa-id="an_rjd_previousChargeExperience_readonly"
            >{{ req.previousChargeExperience | translateExperience |
            nullDash}}</span
          >
        </div>
      </div>

      <div class="row-margin col-item flex-row">
        <strong class="flex-40 nova__label">Years of Experience:</strong>
        <div flex class="flex-60" data-qa-id="an_rjd_yearOfExperience_readonly">
          {{req.yearOfExperience | nullDash}}<span *ngIf="req.yearOfExperience"> year(s)</span>
          <span *ngIf="req.minimumExperienceRequiredOther">
          <br/> Note: {{req.minimumExperienceRequiredOther}}</span>
        </div>
      </div>

      <div class="row-margin col-item flex-row">
        <strong class="flex-40 nova__label">Patient Ratio Experience:</strong>
        <span
          flex
          class="flex-60"
          data-qa-id="an_rjd_patientRatioExperience_readonly"
        >
          {{req.patientRatioExperience | staffingRatio | nullDash}}</span
        >
      </div>


        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Charting System:</strong>
          <span
            flex
            class="flex-60 capitalize"
            data-qa-id="an_rjd_chartingSystemName_readonly"
          >
          {{ req.chartingSystemExperience | translateExperience | nullDash}}<span *ngIf="(req.chartingSystemExperience | translateExperience | nullDash) !== '-'">, {{(req.chartingSystemName | nullDash) === '-'? 'Any' : req.chartingSystemName}}</span></span>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label"
            >Teaching Hospital Experience:</strong
          >
          <span
            flex
            class="flex-60 capitalize"
            data-qa-id="an_rjd_teachingHospitalExperience_readonly"
            >{{req.teachingHospitalExperience | translateExperience | nullDash}}</span
          >
        </div>

      <div class="row-margin col-item flex-row">
        <strong class="flex-40 nova__label"
          >Community Hospital Experience:</strong
        >
        <span
          flex
          class="flex-60 capitalize"
          data-qa-id="an_rjd_communityHospitalExperience_readonly"
          >{{req.communityHospitalExperience | translateExperience |
          nullDash}}</span
        >
      </div>

      <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label"
            >LTAC Experience:</strong
          >
          <span
            flex
            class="flex-60 capitalize"
            data-qa-id="an_rjd_ltacExperience_readonly"
            >{{ req.ltacExperience | translateExperience |
            nullDash}}</span
          >
        </div>

      <div class="row-margin col-item flex-row">
        <strong class="flex-40 nova__label">Trauma Level I Experience:</strong>
        <span
          flex
          class="flex-60 capitalize"
          data-qa-id="an_rjd_traumaLevelIExperience_readonly"
          >{{req.traumaLevelIExperience | translateExperience | nullDash}}</span
        >
      </div>

      <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Trauma Level II Experience:</strong>
          <span
            flex
            class="flex-60 capitalize"
            data-qa-id="an_rjd_traumaLevelIExperience_readonly"
            >{{req.traumaLevelIIExperience | translateExperience | nullDash}}</span
          >
      </div>
      <div class="row-margin col-item flex-row">
        <strong class="flex-40 nova__label">Travel Experience Required:</strong>
        <div
          flex
          class="flex-60"
          data-qa-id="an_rjd_travelExperienceRequired_readonly"
        >
          <span class="capitalize"
            >{{req.travelExperience | translateExperience | nullDash}}</span
          >
          <span *ngIf="req.unitAcceptsFirstTimeTravelerOther">
            <br/>
            Note: {{req.unitAcceptsFirstTimeTravelerOther}}</span
          >
        </div>
      </div>


      <div class="row-margin col-item flex-row">
        <div class="flex-40">
          <strong class="nova__label">Certifications:</strong>
          <br />
          <span class="note">Certs marked with * are preferred</span>
        </div>
        <span flex class="flex-60" data-qa-id="an_rjd_certifications_readonly">
          {{req.certifications | extractCertificationTitles}}
        </span>
      </div>

      <div class="row-margin col-item flex-row">
        <div class="flex-40">
          <strong class="nova__label">Skills:</strong>
          <br />
          <span class="note">Skills marked with * are preferred</span>
        </div>
        <div flex class="flex-60" data-qa-id="an_rjd_skills_readonly">
          <ng-container *ngIf="req.skills && req.skills.length > 0; else noSkills">
            <div
              *ngFor="let category of getUniqueSkillsCategories(req.skills); let isFirst = first"
              [ngClass]="{'first-skill-set': isFirst}"
            >
              <p
                class="skill-category"
                data-qa-id="an_rjd_skillCategory_readonly"
              >
                {{ category }}
              </p>
              <div
                *ngFor="let skill of getSkillsByCategory(req.skills, category)"
              >
                <span data-qa-id="an_rjd_skillName_readonly"
                  >{{ skill.name }}<span *ngIf="skill.isPreferred">*</span></span>
              </div>
            </div>
          </ng-container>
          <ng-template #noSkills>-</ng-template>

        </div>
      </div>
    </ng-template>
    <mat-card data-qa-id="unit-details" *ngIf="showUnitDetails && data.unitRequirements; let req" class="job-unit-requirements" [ngClass]="useClass">
      <div>
        <div class="row-margin">
          <h1>Unit Details</h1>
          <p class="sub-title">Staffing & Scheduling</p>
          <div class="col-item flex-row">
            <strong class="flex-40 nova__label">Scheduling Type:</strong>
            <span flex class="flex-60" data-qa-id="an_rjd_schedulingType_readonly"
              >{{req.schedulingType | nullDash | titlecase }}</span
            >
          </div>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Patient Ratios: </strong>
          <div
            flex
            class="flex-60"
            data-qa-id="an_rjd_patientRatioExperience_readonly"
          >
            <span>Days: {{req.staffingRatioDays | staffingRatio | nullDash }}</span><br />
            <span>Nights: {{req.staffingRatioNights | staffingRatio | nullDash }}</span><br />
            <span>Weekends: {{req.staffingRatioWeekends | staffingRatio | nullDash }}</span>
          </div>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Float Required:</strong>
          <div flex class="flex-60" data-qa-id="an_rjd_floatRequired_readonly">
            <span *ngIf="req.floatRequired !== null; else noFloatRequired">
                Yes
                <br /><span *ngIf="req.floatRequired">Note: </span>{{ req.floatRequired }}
            </span>
            <ng-template #noFloatRequired>-</ng-template>
          </div>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Call Required:</strong>
          <div flex class="flex-60" data-qa-id="an_rjd_callRequired_readonly">
            <span *ngIf="req.callRequired !== null; else noCallRequired">
                Yes
                <br /><span *ngIf="req.callRequired">Note: </span>{{ req.callRequired }}
            </span>
            <ng-template #noCallRequired>-</ng-template>
          </div>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Weekend Coverage:</strong>
          <div flex class="flex-60" data-qa-id="an_rjd_weekendCoverage_readonly">
            <div *ngIf="req.weekendCoverageEveryOther">Every Other</div>
            <div *ngIf="req.weekendCoverageEveryThird">Every Third</div>
            <div
              *ngIf="!req.weekendCoverageEveryThird && !req.weekendCoverageEveryOther"
            >
              -
            </div>
          </div>
        </div>
        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label"
            >Number of Weekend Shifts Per Contract:</strong
          >
          <span
            flex
            class="flex-60"
            data-qa-id="an_rjd_weekendShiftPerContract_readonly"
            >{{req.weekendShiftPerContract | nullDash }}</span
          >
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Pre-Approved Time Off:</strong>
          <div
            flex
            class="flex-60"
            data-qa-id="an_rjd_preApprovedTimeOffPerContract_readonly"
          >
            <ng-container
              *ngIf="req.preApprovedTimeOffPerContract; let toff; else elseBlock"
            >
              <span *ngIf="toff === 'one'">1 Request</span>
              <span *ngIf="toff === 'two'">2 Requests</span>
              <span *ngIf="toff === 'none'">None</span>
            </ng-container>
            <ng-template #elseBlock>
              <span>-</span>
            </ng-template>
          </div>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Orientation Hours:</strong>
          <span flex class="flex-60" data-qa-id="an_rjd_orientationHours_readonly"
            >{{req.orientationHours | nullDash }}</span
          >
        </div>

        <div class="row-margin">
          <p class="sub-title">Facility & Patient Care Details</p>
          <div class="col-item flex-row">
            <strong class="flex-40 nova__label">Patient Age Groups:</strong>
            <span
              flex
              class="flex-60"
              data-qa-id="an_rjd_patientAgeGroup_readonly"
            >
              {{req.patientAgeGroups | joinComma }}
            </span>
          </div>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Daily Census:</strong>
          <span
            flex
            class="flex-60"
            data-qa-id="an_rjd_averageDailyCensus_readonly"
            >{{req.averageDailyCensus | nullDash}}</span
          >
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Number of Visits Per Day:</strong>
          <span flex class="flex-60" data-qa-id="an_rjd_visitsDays_readonly"
            >{{req.visitsDays | nullDash}}</span
          >
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Number of Rooms:</strong>
          <span flex class="flex-60" data-qa-id="an_rjd_rooms_readonly"
            >{{req.rooms | nullDash}}</span
          >
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Number of Beds:</strong>
          <span flex class="flex-60" data-qa-id="an_rjd_beds_readonly"
            >{{req.beds | nullDash}}</span
          >
        </div>

        <div class="row-margin">
          <p class="sub-title">Additional Unit Information</p>
          <div class="col-item flex-row">
            <strong class="flex-40 nova__label"
              >Interdisciplinary Support:</strong
            >
            <span
              flex
              class="flex-60"
              data-qa-id="an_rjd_interdisciplinarySupport_readonly"
              >{{req.providerSupports | joinComma }}</span
            >
          </div>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Patient Diagnoses:</strong>
          <span
            flex
            class="flex-60"
            data-qa-id="an_rjd_patientPopulation_readonly"
            [innerHtml]="req.patientPopulation | textFormat | nullDash"
          ></span>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label"
            >Special Procedures/Unit Details:</strong
          >
          <span
            flex
            class="flex-60"
            data-qa-id="an_rjd_unitDetails_readonly"
            [innerHtml]="req.unitDetails | textFormat | nullDash"
          ></span>
        </div>

        <div class="row-margin col-item flex-row">
          <strong class="flex-40 nova__label">Special Equipment:</strong>
          <span
            flex
            class="flex-60"
            data-qa-id="an_rjd_specialEquipment_readonly"
            [innerHtml]="req.specialEquipment | textFormat | nullDash"
          ></span>
        </div>
      </div>
    </mat-card>
  </ng-container>
</ng-template>
